import { Stack, UnorderedList, ListItem, Text } from '@chakra-ui/react'
import {
  SmallItem,
  WorksheetFieldPermissionType,
} from 'src/legacy_modules/entities/small-item/entity'

type RolePermissionDisplayProps = {
  smallItem: SmallItem
}

const roleLabels: Record<string, string> = {
  MainDr: '実施医療機関 Dr',
  MainCRC: '実施医療機関 CRC',
  PartnerDr: 'パートナー Dr',
  PartnerCRC: 'パートナー CRC',
}

const permissionTypeLabels: Record<WorksheetFieldPermissionType, string> = {
  Edit: '編集可能',
  ReadOnly: '読み取り専用',
  Hidden: '値非表示',
}

export const RolePermissionDisplay: React.FC<RolePermissionDisplayProps> = ({
  smallItem,
}) => {
  if (smallItem.rolePermissions.length === 0) {
    return null
  }

  return (
    <Stack spacing="1">
      <Text fontWeight="bold" fontSize="sm" color="gray.600">
        入力権限
      </Text>
      <UnorderedList>
        {smallItem.rolePermissions.map((rp, index) => (
          <ListItem key={index}>
            {roleLabels[rp.role] || rp.role}:{' '}
            {permissionTypeLabels[rp.permissionType] || rp.permissionType}
          </ListItem>
        ))}
      </UnorderedList>
    </Stack>
  )
}
